module.exports = __webpack_public_path__ + "img/dropbox.203cef8e.svg";